import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { PREVIEW_MODE_DATE_PARAM, cleanEffectiveDateTime } from '../../utils/preview-mode-utils';
import { useSSRPreviewMode } from './useSSRPreviewMode';
import { useShopperContextGet } from './useShopperContextGet';

export const useEffectiveDateTime = (): string => {
    const isSSRPreviewMode = useSSRPreviewMode();
    const location = useLocation();
    const shopperContext = useShopperContextGet();
    const previewDateParam = useMemo(
        () => new URLSearchParams(location.search).get(PREVIEW_MODE_DATE_PARAM),
        [location.search],
    );
    const effectiveDateTime = useMemo(() => {
        if (isSSRPreviewMode) {
            if (previewDateParam) {
                return previewDateParam;
            }
            if (shopperContext?.effectiveDateTime) {
                return cleanEffectiveDateTime(shopperContext.effectiveDateTime as string);
            }
        }
        return '';
    }, [isSSRPreviewMode, previewDateParam, shopperContext?.effectiveDateTime]);
    return effectiveDateTime;
};
